import cloneDeep from 'lodash/cloneDeep';
import {Logger} from '@milestoneslabs/milestones-js-engine';

export default {
    props: {
        value: {},
    },
    data() {
        return {
            internalModel: typeof this.value === 'object' ? cloneDeep(this.value) : this.value,
        };
    },
    watch: {
        value(newVal) {
            this.internalModel = newVal;
        },
        internalModel: {
            deep: true,
            handler() {
                this.$emit('input', this.internalModel);
            },
        },
    },
};
